import BestAlternative from "./pages/BestAlternative";
import UltimateGuide from "./pages/UtilmateGuide";
import MolecularCloning from "./pages/MolecularCloning";
import HistoryOfScientificMethod from "./pages/ScientificMethod";
import HistoryOfScientificMethodPart2 from "./pages/Chapter2";
import HistoryOfScientificMethodPart3 from "./pages/Chapter3";

import CloningImage from "../../assets/images/articles/cloning/image.png";
import Alternative from "../../assets/images/articles/alternatives/image.png";
import Guide from "../../assets/images/articles/guide/image.png";
import History from "../../assets/images/articles/history/image.png";
import Cover2 from "../../assets/images/articles/history/cover2.png";
import Cover3 from "../../assets/images/articles/history/cover3.png";

/**
 * Can modify this , use it for filtering
 */
export type ArticleType = "Software Tools" | "PCR" | "Molecular Cloning" | "Video" | "History of Science";
export interface ResourceData {
  href: string;
  title: string;
  shortDescription: string;
  mainPageContent?: React.FC;
  image: string;
  category: ArticleType;
  readTime: string;
  date: string;
  youtubeUrl?: string; 
}


/**
 * Resource Article lists
 * currently static data
 * all article content are created manually
 */
const resourcesList: ResourceData[] = [
  {
    href: "snapgene-alternatives-2026",
    title: "The 7 Best SnapGene Alternatives in 2026 (Free & Paid Options)",
    shortDescription:
      "Discover modern, affordable, and collaborative plasmid design tools beyond SnapGene — from Benchling to Photo51.",
    mainPageContent: BestAlternative,
    image: Alternative,
    category: "Software Tools",
    readTime: "10 min read",
    date: "2025-11-04",
  },
  {
    href: "pcr-primer-design-guide",
    title: "The Ultimate Guide to PCR Primer Design",
    shortDescription:
      "Master the 9 golden rules of primer design — learn how to create efficient, specific primers for PCR, qPCR, and cloning.",
    mainPageContent: UltimateGuide,
    image: Guide,
    category: "PCR",
    readTime: "8 min read",
    date: "2025-11-03",
  },
  {
    href: "history-of-molecular-cloning",
    title: "The History of Molecular Cloning",
    shortDescription:
      "From restriction enzymes to Gibson Assembly — explore 50 years of breakthroughs that shaped modern biotechnology.",
    mainPageContent: MolecularCloning,
    image: CloningImage,
    category: "Molecular Cloning",
    readTime: "12 min read",
    date: "2025-11-01",
  },
  {
    href: "history-of-scientific-method-part1",
    title: "The History of the Scientific Method: Part 1",
    shortDescription:
      "Introduction to the origins of scientific methodology and the modern reproducibility crisis — why documentation and transparency remain essential.",
    mainPageContent: HistoryOfScientificMethod,
    image: History,
    category: "History of Science",
    readTime: "7 min read",
    date: "2025-11-05",
  },
  {
    href: "history-of-scientific-method-part2",
    title: "The History of the Scientific Method: Part 2",
    shortDescription:
      "Ancient Science: Egypt, Greece, & the Islamic Golden Age.",
    mainPageContent: HistoryOfScientificMethodPart2,
    image: Cover2,
    category: "History of Science",
    readTime: "8 min read",
    date: "2025-12-05",
  },
  {
    href: "history-of-scientific-method-part3",
    title: "The History of the Scientific Method: Part 3",
    shortDescription:
      "The Scientific Revolution: Bacon, Boyle & the Rise of Scientific Societies.",
    mainPageContent: HistoryOfScientificMethodPart3,
    image: Cover3,
    category: "History of Science",
    readTime: "7 min read",
    date: "2025-12-05",
  },
  {
    href: "how-to-access-photo51",
    title: "How to access Photo51",
    shortDescription:
      "Watch how to sign up and access the molecular biology software Photo51",
    image: "https://img.youtube.com/vi/DUKnuSwpZ6U/maxresdefault.jpg",
    category: "Video",
    readTime: "Video • 0.28 min",
    date: "2025-03-01",
    youtubeUrl: "https://www.youtube.com/embed/DUKnuSwpZ6U",
  },
  {
    href: "how-to-upload-files-photo51",
    title: "How to upload files in Photo51",
    shortDescription:
      "Watch how to import files into Photo51, the molecular biology software.",
    image: "https://img.youtube.com/vi/vWY8bw0mOg8/maxresdefault.jpg",
    category: "Video",
    readTime: "Video • 0.48 min",
    date: "2025-03-01",
    youtubeUrl: "https://www.youtube.com/embed/vWY8bw0mOg8",
  },
  {
    href: "how-to-organize-files-photo51",
    title: "How to organize files in Photo51",
    shortDescription:
      "Watch the basics of creating new folders, moving files, deleting files and recovering files in Photo51",
    image: "https://img.youtube.com/vi/n8A_yuvyhOQ/maxresdefault.jpg",
    category: "Video",
    readTime: "Video • 1.38 min",
    date: "2025-03-01",
    youtubeUrl: "https://www.youtube.com/embed/n8A_yuvyhOQ",
  },
  {
    href: "how-to-analyze-plasmids-photo51",
    title: "How to analyze plasmids in Photo51",
    shortDescription:
      "Watch the basics of analyzing a plasmid file in Photo51 the molecular biology software. It goes over things like moving between map and sequence view, the split screen feature, all the overview tabs within the navigation bar and how to use these to better understand you plasmid.",
    image: "https://img.youtube.com/vi/n8A_yuvyhOQ/maxresdefault.jpg",
    category: "Video",
    readTime: "Video • 3.48 min",
    date: "2025-03-01",
    youtubeUrl: "https://www.youtube.com/embed/n8A_yuvyhOQ",
  },
  {
    href: "how-to-do-Gateway-BP-cloning",
    title: "How to do Gateway BP Cloning in Photo51",
    shortDescription:
      "Watch how to perform BP Cloning in Photo51, the molecular biology software.",
    image: "https://img.youtube.com/vi/H4PRRJWaTGI/maxresdefault.jpg",
    category: "Video",
    readTime: "Video • 2.59 min",
    date: "2025-03-01",
    youtubeUrl: "https://www.youtube.com/embed/H4PRRJWaTGI",
  },
  {
    href: "how-to-do-Gateway-LR-cloning",
    title: "How to do Gateway LR Cloning in Photo51",
    shortDescription:
      "Watch how to perform LR Cloning in Photo51, the molecular biology software.",
    image: "https://img.youtube.com/vi/ConBkbrrufs/maxresdefault.jpg",
    category: "Video",
    readTime: "Video • 3.21 min",
    date: "2025-03-01",
    youtubeUrl: "https://www.youtube.com/embed/ConBkbrrufs",
  },
  {
    href: "how-to-do-Gibson-assembly-cloning",
    title: "How to do Gibson Assembly Cloning in Photo51",
    shortDescription:
      "Watch how to perform Gibson Assembly Cloning in Photo51, the molecular biology software.",
    image: "https://img.youtube.com/vi/xM9r7RN9I5s/maxresdefault.jpg",
    category: "Video",
    readTime: "Video • 3.15 min",
    date: "2025-03-01",
    youtubeUrl: "https://www.youtube.com/embed/xM9r7RN9I5s",
  },
  {
    href: "how-to-do-infusion-cloning",
    title: "How to do InFusion Cloning in Photo51",
    shortDescription:
      "Watch how to perform InFusion Cloning in Photo51, the molecular biology software.",
    image: "https://img.youtube.com/vi/mC3WzSKoe7M/maxresdefault.jpg",
    category: "Video",
    readTime: "Video • 3.26 min",
    date: "2025-03-01",
    youtubeUrl: "https://www.youtube.com/embed/mC3WzSKoe7M",
  },
  {
    href: "how-to-do-hifi-assembly-cloning",
    title: "How to do HiFi Assembly Cloning in Photo51",
    shortDescription:
      "Watch how to perform HiFi Assembly Cloning in Photo51, the molecular biology software.",
    image: "https://img.youtube.com/vi/3g64RDSf-9M/maxresdefault.jpg",
    category: "Video",
    readTime: "Video • 3.30 min",
    date: "2025-03-01",
    youtubeUrl: "https://www.youtube.com/embed/3g64RDSf-9M",
  },
  {
    href: "how-to-do-restriction-cloning",
    title: "How to do Restriction Cloning in Photo51",
    shortDescription:
      "Watch how to perform Restriction Cloning in Photo51, the molecular biology software.",
    image: "https://img.youtube.com/vi/HAc2smSF4JE/maxresdefault.jpg",
    category: "Video",
    readTime: "Video • 2.36 min",
    date: "2025-03-01",
    youtubeUrl: "https://www.youtube.com/embed/HAc2smSF4JE",
  },
   {
    href: "how-to-do-ta-cloning",
    title: "How to do TA Cloning in Photo51",
    shortDescription:
      "Watch how to perform TA Cloning in Photo51, the molecular biology software.",
    image: "https://img.youtube.com/vi/tNViID5_tiQ/maxresdefault.jpg",
    category: "Video",
    readTime: "Video • 2.18 min",
    date: "2025-03-01",
    youtubeUrl: "https://www.youtube.com/embed/tNViID5_tiQ",
  },
  {
    href: "how-to-do-golden-gate-cloning",
    title: "How to do Golden Gate Cloning in Photo51",
    shortDescription:
      "Watch how to perform Golden Gate Cloning in Photo51, the molecular biology software.",
    image: "https://img.youtube.com/vi/fCgmTOA3nog/maxresdefault.jpg",
    category: "Video",
    readTime: "Video • 3.11 min",
    date: "2025-03-01",
    youtubeUrl: "https://www.youtube.com/embed/fCgmTOA3nog",
  },
  {
    href: "how-to-create-virtual-gel",
    title: "How to create Virtual Gel in Photo51",
    shortDescription:
      "Watch how to create virtual gel electrophoresis simulations in Photo51 to ensure all your fragments are the expected sizes!",
    image: "https://img.youtube.com/vi/exkmc0RNwUw/maxresdefault.jpg",
    category: "Video",
    readTime: "Video • 3.00 min",
    date: "2025-03-01",
    youtubeUrl: "https://www.youtube.com/embed/exkmc0RNwUw",
  },
  {
    href: "how-to-do-sequence-alignment",
    title: "How to do Sequence Alignment in Photo51",
    shortDescription:
      "Watch how to align sequences to a reference, how to do a local or global pairwise alignment and how to align multiple sequences using MUSCLE or MAFFT algorithms.",
    image: "https://img.youtube.com/vi/D2DFgdEjduA/maxresdefault.jpg",
    category: "Video",
    readTime: "Video • 4.24 min",
    date: "2025-03-01",
    youtubeUrl: "https://www.youtube.com/embed/D2DFgdEjduA",
  },
   {
    href: "how-to-use-crispr-cas-tools",
    title: "How to use CRISPR-Cas Tools in Photo51",
    shortDescription:
      "Watch how to get started using the CRISPR-Cas tools in Photo51 the molecular biology software. The video covers guide RNA creation and exporting as well as filtering for specific codon conversion for base editing systems.",
    image: "https://img.youtube.com/vi/W7BjQNNeU5U/maxresdefault.jpg",
    category: "Video",
    readTime: "Video • 4.24 min",
    date: "2025-03-01",
    youtubeUrl: "https://www.youtube.com/embed/W7BjQNNeU5U",
  },
];

export default resourcesList;
